module.exports = __webpack_public_path__ + "img/1507758263.019aab0a.jpg";